import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicLanguage, usePublicTr } from '../contexts/PublicLanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import './PublicLayout.css';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { t } = usePublicLanguage();
  const tr = usePublicTr();
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <div className="public-layout">
      <nav className="public-nav">
        <div className="public-nav-content">
          <Link to="/" className="public-logo">
            <div className="logo-box-nav">
              <img src="/logo192.png" alt="Yarnboard" className="brand-logo-img" />
            </div>
            <span className="logo-text">Yarnboard</span>
          </Link>
          
          <div className="public-nav-right">
            <div className="public-nav-links">
              <Link to="/" className="nav-link">{t.nav.home}</Link>
              <Link to="/about" className="nav-link">{t.nav.about}</Link>
              <Link to="/pricing" className="nav-link">{tr('Pricing', 'Precios', 'Preços')}</Link>
              {isAuthenticated ? (
                <Link to="/" className="nav-link nav-login-button">
                  {tr('My Board', 'Mi tablero', 'Meu quadro')}
                </Link>
              ) : (
                <Link to="/login" className="nav-link nav-login-button">{t.nav.login}</Link>
              )}
            </div>
            <LanguageSwitcher />
          </div>
        </div>
      </nav>
      
      <main className="public-content">
        {children}
      </main>
      
      <footer className="public-footer">
        <div className="footer-content">
          <p>{t.footer.madeWith}</p>
          <div className="footer-links">
            <a href="/privacy" className="footer-link">{t.footer.privacyPolicy}</a>
            <span className="footer-separator">•</span>
            <Link to="/terms" className="footer-link">{t.footer.terms}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
